var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.344 17.778C15.344 17.364 15.008 17.028 14.594 17.028H9.434C9.02 17.028 8.684 17.364 8.684 17.778C8.684 18.192 9.02 18.528 9.434 18.528H14.594C15.008 18.528 15.344 18.192 15.344 17.778ZM17.55 13.778C17.55 13.364 17.214 13.028 16.8 13.028H7.204C6.79 13.028 6.454 13.364 6.454 13.778C6.454 14.192 6.79 14.528 7.204 14.528H16.8C17.214 14.528 17.55 14.192 17.55 13.778ZM20 9.77802C20 9.36402 19.664 9.02802 19.25 9.02802H4.75C4.336 9.02802 4 9.36402 4 9.77802C4 10.192 4.336 10.528 4.75 10.528H19.25C19.664 10.528 20 10.192 20 9.77802ZM22 5.77802C22 5.36402 21.664 5.02802 21.25 5.02802H2.75C2.336 5.02802 2 5.36402 2 5.77802C2 6.19202 2.336 6.52802 2.75 6.52802H21.25C21.664 6.52802 22 6.19202 22 5.77802Z",
    fill: "#403CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filterActive.dc45c8974122f3d8deb64fb100c3eb03.svg";
export { ForwardRef as ReactComponent };